<template>
<div  style= "background:#272a36;width:100%;height:100%" >
  <solution :solutionObj = "obj"/>
        <div class="i_box slt animate__animated animate__fadeInLeft">
            <div class="box_m">
              <ul class="solution i_solution clearfix">
                <kinesis-container class="clearfix" style="display: inline-block;" v-for="(item,index) in obj.children" :key="index"> 
                  <!-- <kinesis-element type="depth" :strength='15' > -->
                  <li class="li1" @click="goSolutionDetail(item)" :style="`background-image: url(${item.articles.thumb});`">
                      <div class="soluteIn" >
                        <div class="soluteInItem" >
                          <div class = "soluteInItemTop" >
                            <span>+</span>
                          </div>
                        </div>
                       
                      </div>
                       <div class = "soluteInItemBottom">
                          <span class="tit">{{item.name}}</span>
                          <span class="content">{{item.sub_name}}</span>
                        </div>
                    </li>
                   
                  <!-- </kinesis-element> -->
                    </kinesis-container>
                    
                </ul>
            </div>
        </div>
</div>
</template>
<script>
import solution from '@/views/home/components/solution'
import { KinesisContainer, KinesisElement} from 'vue-kinesis'  
export default {
  name: 'App',
   components:{
    solution,
    KinesisContainer,
    // KinesisElement
  },
  props: {
    obj: {
      type: Object,
      default: function() {
        return {}
      }
    },
    subTitleStyle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Solution'
    },
    subTitle: {
      type: String,
      default: '解决方案'
    }
  },
  data() {  
    return {  
     images: [  
       
      ] 
    };  
  }, 

  methods:{
    goSolutionDetail(item) {
      this.$router.push({ path: '/solutionDetail' ,query:{id:item.articles.id,model_type:item.model_type}})
    }
  }
}
</script>
<style lang="scss" scoped>
.i_box{ width:100%; padding:5px 0 80px 0; margin:0px auto;}
.i_box .box_m{ margin-top:60px;}
.solution{ width:100%; max-width:1200px; margin:0px auto;}
.solution li{ width:290px; height:502px; background: no-repeat center/cover padding-box content-box;float:left; margin-right:10px; position:relative; overflow:hidden;}
.clearfix{display:block}
li:hover{
  .soluteIn{
    opacity:0.5 !important;
  }
  .soluteInItemBottom{
    opacity:1 !important;
  }
}
.soluteIn {
  background:#272a36;width:100%;height:100%;;position:absolute;left:0;top:0;
  opacity: 0;
  transition: opacity 0.5s ;
  
}
.soluteInItem {
    border:1px solid #fff;margin:8% auto;width:90%;height:90%;
  }
.soluteInItemTop{font-size:70px;color:#fff;text-align:center;margin:35px auto;}
.soluteInItemTop span {font-weight: 100;}
.soluteInItemBottom{
  opacity: 0;
}
.soluteInItemBottom span {
  color: #fff;
  display: block;
}
.soluteInItemBottom span.tit {
  font-size:28px;
  position: absolute;
  bottom:90px;
  left:80px;
}
.soluteInItemBottom span.content {
  font-size:14px;
  position: absolute;
  bottom:50px;
  width:100%;
  text-align: center;
  letter-spacing: 1px;
}
</style>
